import { GetCounterDeliveriesProps } from "@/services/counter-delivery.service";
import dayjs, { Dayjs } from "dayjs";

export interface CDFRProps {
  order_date?: Dayjs;
  account_owner: string;
  order_amount: string;
  grain: number
  ton: number
  estado?: string[];
}

export const getCounterDeliveriesFilter = (
  event: CDFRProps,
): Partial<GetCounterDeliveriesProps> => {
  let order_amount;

  if (event?.order_amount) {
    const cleaned = event?.order_amount
      .replaceAll(/[^0-9,.-]/g, "")
      .replaceAll(".", "")       
      .replaceAll(",", "."); 

    order_amount = Number.parseFloat(cleaned).toFixed(2);
  }

  return {
    ...(event?.order_date && dayjs(event?.order_date).isValid()
      ? {
          fecha: dayjs(event?.order_date).toISOString(),
        }
      : {}),
    ...(event?.estado?.length
      ? {
          estado: event?.estado,
        }
      : {}),
    ...(event?.account_owner
      ? {
          titular: event?.account_owner,
        }
      : {}),
    ...(event?.order_amount && order_amount
      ? {
          monto: Number(order_amount),
        }
      : {}),
      ...(event?.ton ? {
        toneladas: Number(event?.ton)
      } : {}),
      ...(event.grain ? {
        grano: event?.grain 
      } : {})
  };
};
